
import { i18nText } from '@/locales';

import {Component, Vue, Watch} from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import SalonGeneralFormComponent from "@/UI/components/forms/Studios/SalonGeneralForm.vue";
import StudioTransfer from "@/UI/pages/salons/components/StudioTransfer.vue";
import {mixins} from "vue-class-component";
import moment from "moment";
import {FormModel, message, notification} from "ant-design-vue";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import dayjs from "dayjs";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import CreateFormSalon from "@/UI/pages/salons/components/CreateFormSalon.vue"
import {SalonForm} from "@/UI/pages/salons/lib/SalonForm";
import {ProxyTableData} from "../Helpers/ProxyTableData";
import {SalonsStore} from "@/store/modules/Salons";
import {checkUserRole} from "@/router/Lib/helper";
import {RouterNameEnum} from "@/router/router.types";
import {getStudioId} from "@/UI/lib/state";

@Component({
  components: {
    SalonGeneralFormComponent,
    PageTitle,
    FormGroup,
    StudioTransfer,
    BaseDataForm,
    CreateFormSalon
  },
  methods: {moment, dayjs, checkUserRole},
})
export default class SalonGeneral extends mixins(
    ProxyTableData
) {
  form = new SalonForm()
  isAllowToSave = false;


  async deleteSalon(): Promise<void> {
    const response = await SalonsStore.delete({id: parseInt(this.$route.params.id)})
    if (response.status) {
      message.success(i18nText("Студия успешно удалена"));
      await this.$router.push({
        name: RouterNameEnum.Salons,
        params: {
          Studio: getStudioId(this)
        }
      })
    } else {
      message.error(response.response);
      if (response.additional) {
        response.additional.map((error: string) => message.error(error));
      }
    }
  }

  @Watch('form', {immediate: false, deep: true})
  allowSave(): void {
    if (this.$refs.studioForm !== undefined && this.formReady) {
      ((this.$refs.studioForm as any).$refs.studioForm as FormModel).validate((valid) => {
        if (valid) {
          this.isAllowToSave = true;
        } else if(this.isAllowToSave) {
          this.isAllowToSave = false;
        }
      });
    }
  }

  async submit(): Promise<void> {
    ((this.$refs.studioForm as any).$refs.studioForm as FormModel).validate((valid) => {
      if (valid) {
        let data = {
          id: this.form.id,
          active: !!this.form.active,
          name: this.form.salon_name,
          city_id: this.form.city_id,
          partner_id: this.form.partner_id,
          partner: {
            id: this.form.partner_id,
            name: this.form.partner_name,
            phone: this.form.partner_phone,
            email: this.form.partner_email,
            social_network: this.form.partner_social_network,
          },
          opening_date: this.form.opening_date,
          work_time_from: moment(this.form.work_time_from).format('HH:mm'),
          work_time_to: moment(this.form.work_time_to).format('HH:mm'),
          phone: this.form.phone,
          address: this.form.address,
          social_network_link: this.form.social_network_link,
          salon_group_id: this.form.salon_group_id,
          conclusion_contract_date: this.form.conclusion_contract_date,
          currency_id: this.form.currency_id,
          transfer: this.form.transfer,
          legal_entity_data: {
            id: this.form.legal_entity_id,
            name: this.form.legal_entity_name,
            legal_address: this.form.legal_address,
            actual_address: null,
            legal_entity_data_INN: this.form.legal_entity_data_INN,
            legal_entity_data_KPP: this.form.legal_entity_data_KPP,
            account: {
              RCBIC: this.form.account_RCBIC,
              bank_name: this.form.bank_name,
              correspondent_account: this.form.correspondent_account,
              checking_account: this.form.checking_account,
            }
          }
        }

        SalonsStore.update(data as any).then((response) => {
          if (response.status) {
            this.$message.info(i18nText("Студия успешно обновлена"))
          } else {
            this.$message.error(response.response)
          }
        })
      } else {
        this.$message.error(i18nText("Ошибка, пожалуйста заполните все обязательные поля"));
      }
    });
  }

  async created(): Promise<void> {
    this.formReady = false
    try {
      await this.fetchModule([
        {s: 'currency'},
        ...(Vue.auth.check('admin') ? [{s: 'groups'}] : []),
        {s: 'salons', p: {filter: {id: Vue.router.currentRoute.params.id}}}
      ])
      this.form.setFormData(this.salons)

      let cityQueryParams = {};

      if(this.form.city_id) {
        cityQueryParams = { options: { start: this.form.city_id } };
      }

      await this.fetchModule([{s: 'territory', p: cityQueryParams}])
    } catch (e) {
      console.error(e)
    } finally {
      this.formReady = true
    }
  }

  get salons() {
    return SalonsStore.salons?.data[0]
  }
}
